import AbstractDropdownButton from './abstract_dropdown_button'
import DropdownListButton from './dropdown_list_button'
import Ext from 'Ext'

const ListSelector = Ext.extend(AbstractDropdownButton, {

    menuCls: "",
    listItems: [],
    textPropName: "text",
    valuePropName: "value",
    clsPropName: "styleCls",
    value: null,
    maxNonScrollableItems: 10,

    // private
    currentItem: null,

    initComponent: function() {
        this.addEvents("change");

        this.itemClickHandler = (item) => {
            let wasActuallySet = this.setItem(item);
            if (wasActuallySet)
                this.fireEvent("change", this, item.origObj);
        };

        let mCls = "at-dropdown-list-btn-menu ";
        if (this.listItems.length > this.maxNonScrollableItems)
            mCls += "scrollable ";
        mCls += this.menuCls;


        this.menu = new Ext.menu.Menu({
            cls: mCls,
            parentEl: this.renderTo,
        })

        if (this.listItems.length !== 0) {
            this.addItems(this.listItems);

            if (!this.currentItem)
                this.setItem(this.menu.items.items[0]);
        }
        this.cls = "at-dropdown-list-btn " + (this.cls ? this.cls : "");
        this.ctCls = "at-dropdown-list-btn-ct " + (this.ctCls ? this.ctCls : "");

        DropdownListButton.superclass.initComponent.call(this);
    },

    setItem: function(item) {
        if (this.currentItem) {
            if (this.currentItem === item)
                return false;
            this.currentItem.setIconClass("");
        }
        this.currentItem = item;
        this.currentItem.setIconClass("selected");
        this.value = item.value;
        this.setText(item.text);
        return true;
    },

    setActiveItemByValue: function(value, suppressChangeEvent) {
        let item = this.menu.items.find(function(item) { return item.value === value; });
        if (item) {
            this.setItem(item);
            if (!suppressChangeEvent)
                this.fireEvent("change", this, item.origObj);
        }
    },

    /**
     * @deprecated
     */
    getValue: function() {
        return this.value;
    },

    getSelectedItem: function() {
        return this.currentItem == null ? null : this.currentItem.origObj;
    },

    createItem: function(listItem) {
        return {
            text: listItem[this.textPropName],
            value: listItem[this.valuePropName],
            cls: listItem[this.clsPropName],
            origObj: listItem
        };
    },

    addItems: function(listItems) {
        for (let i = 0; i < listItems.length; i++) {
            const listItem = listItems[i];

            const itemConfig = this.createItem(listItem);
            itemConfig.listeners = {click: this.itemClickHandler};

            const item = this.menu.addMenuItem(itemConfig);

            if (this.value === item.value)
                this.setItem(item);
        }
    },

    addSeparator: function() {
        this.menu.addSeparator();
    },

    getItemByValue: function(value) {
        return this.menu.items.find(
            function(item) { return item.value === value; });
    }
});

export default ListSelector



// WEBPACK FOOTER //
// ./web/js/controls/ListSelector.js